import { useMediaQuery } from 'react-responsive';

// Value defines the min-width for the correspoding view.
enum Breakpoints {
  desktop = 1048,
  tablet = 540,
}

export const useStandaloneBreakpoints = () => {
  const isDesktop = useMediaQuery({ minWidth: Breakpoints.desktop });
  const isTablet = useMediaQuery({ minWidth: Breakpoints.tablet });
  const isMobile = useMediaQuery({ maxWidth: Breakpoints.tablet - 1 });

  return { isDesktop, isTablet, isMobile };
};
